'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAppSelector } from '@/app/store/hooks';

export default function GuestGuard({ children }: { children: React.ReactNode }) {
    const { token, isAuthenticated } = useAppSelector((state) => state.auth);
    const router = useRouter();

    useEffect(() => {
        if (token && isAuthenticated) {
            router.replace('/');
        }
    }, [token, isAuthenticated, router]);

    if (token && isAuthenticated) return null;

    return <>{children}</>;
}
